import './bootstrap'

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import Vuex from 'vuex'
import mainStore from './store'
import { VueTables, ServerTable, ClientTable, Event } from 'vue-tables-2';
import VueToastr from '@deveodk/vue-toastr'
import { Pagination } from 'vue-pagination-2';
import VueMask from 'v-mask'
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker';
import vSelect from "vue-select";
import { Datetime } from 'vue-datetime'
import { Settings } from 'luxon'

 
Settings.defaultLocale = 'pt-br'

const translation = {
    count: 'Mostrando {from} de {to} de até {count} registros',
    filter: 'Pesquisar:',
    filterPlaceholder: 'Pesquisar',
    limit: 'Registros:',
    noResults: 'Nenhum registro encontrado',
    page: 'Página:',
    last: '>>',
    first: '<<',
    filterBy: 'Filtrar por {column}',
    // for dropdown pagination filterBy: 'Filter by {column}',
    // Placeholder for search fields when filtering by column loading:'Loading...',
    // First request to server defaultOption:'Select {column}'
    // default option for list filters }
}

const options = {
    requestFunction: function (data) {
        // data.token = this.$store.getters.token
        return axios.get(this.url, {
            params: data
        }).catch(function (e) {
            this.dispatch('error', e);
            router.push('/login')
        }.bind(this));
    },
    texts: translation,
    pagination: { chunk: 15, dropdown: false, nav: 'scroll', edge: true},
    perPage: 10,
    perPageValues: [10, 25, 50, 100],
    sortIcon: { base:'fas', up:'fa-chevron-up', down:'fa-chevron-down', is:'fa-sort' }
}

Vue.config.productionTip = false
Vue.use(Vuex)
Vue.use(router)
Vue.use(ServerTable, options, false, 'bootstrap3', 'footerPagination')
Vue.use(ClientTable, options, false, 'bootstrap3', 'footerPagination')
Vue.use(VueToastr)
Vue.use(VueMask);
Vue.use(require('vue-moment'))
Vue.use(Datetime)

Vue.component('VueCtkDateTimePicker', VueCtkDateTimePicker);
Vue.component('date-picker', VueCtkDateTimePicker)
Vue.component('v-select', vSelect)
Vue.component('datetime', Datetime)

export const store = new Vuex.Store(mainStore)

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    store,
    components: { App },
    template: '<App/>',
    created() {
        // auth bootstrap runs in router.beforeEach via initialize()
    },
});

/*
  <link rel="stylesheet" href="src/assets/auxiliary/bootstrap/css/bootstrap.min.css">
    <link rel="stylesheet" href="src/assets/css/style.css">
    <link rel="stylesheet" href="src/assets/auxiliary/animate/animate.css">
    <link rel="stylesheet" href="src/assets/auxiliary/fontawesome/css/all.min.css">
*/

window.$ = require('jquery')
window.JQuery = require('jquery')
window.moment = require('moment')

import './assets/auxiliary/bootstrap/css/bootstrap.min.css'
require('bootstrap')
import '../node_modules/@deveodk/vue-toastr/dist/@deveodk/vue-toastr.css'

import './assets/css/style.css'

// var currentUrl = window.location.hostname;

// if (currentUrl == "estapar.innovsign.com.br") {

//     require('./assets/css/estapar.css')

// } else if (currentUrl == "innovare.innovsign.com.br") {

//     require('./assets/css/innovare.css')

// } else {
//     require('./assets/css/estapar.css')
// }


import './assets/auxiliary/animate/animate.css'
import './assets/auxiliary/fontawesome/css/all.min.css'
import swal from 'sweetalert'
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css';
import 'vue-select/dist/vue-select.css';
import 'vue-datetime/dist/vue-datetime.css'

Vue.prototype.$http = window.axios;
Vue.prototype.$message = function (title, msg, type) {
    let newMsg = '';
    if (msg instanceof Object) {

        newMsg += "<ul>";
        for (var key in msg) {
            if (msg.hasOwnProperty(key)) {
                console.log(key['message'])
                if (type != 'error') {
                    newMsg += "<li>";
                    newMsg += msg[key];
                    newMsg += "</li>";
                } else if (key == 'message' && msg[key] == 'Token has expired.') {
                    newMsg += "<li>";
                    newMsg += 'Sessão expirada.';
                    newMsg += "</li>";
                    break
                } else {
                    newMsg += "<li>";
                    newMsg += msg[key];
                    newMsg += "</li>";
                }
            }
        }
        newMsg += "</ul>";

    } else newMsg = msg;

    this.$toastr('add',
        {
            title: title,
            msg: newMsg,
            clickClose: true,
            timeout: 4000,
            position: 'toast-top-right',
            type: type
        })
};

let csrfRetrying = false;

axios.interceptors.response.use(
    response => response,
    async error => {
        const status = error.response && parseInt(error.response.status);
        const onLoginPage = router.currentRoute && router.currentRoute.path === '/login';

        if (status === 419 && !csrfRetrying && error.config && !error.config.__csrfRetry) {
            csrfRetrying = true;
            error.config.__csrfRetry = true;
            try {
                await store.dispatch('ensureCsrf');
                return await axios.request(error.config);
            } finally {
                csrfRetrying = false;
            }
        }

        if (status === 401 && !onLoginPage) {
            store.commit('clearAuth');
            router.push({ path: '/login' });
            $("#page_loader").hide();
            return Promise.reject(error);
        }

        return Promise.reject(error);
    }
)


// WEBPACK FOOTER //
// ./src/main.js